(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("xes-frontend-ui/lib/utils/ajax"), require("xes-frontend-ui/lib/mixins/styleMixin"), require("xes-frontend-ui/lib/material-content"));
	else if(typeof define === 'function' && define.amd)
		define(["xes-frontend-ui/lib/utils/ajax", "xes-frontend-ui/lib/mixins/styleMixin", "xes-frontend-ui/lib/material-content"], factory);
	else if(typeof exports === 'object')
		exports["VueDropUpload"] = factory(require("xes-frontend-ui/lib/utils/ajax"), require("xes-frontend-ui/lib/mixins/styleMixin"), require("xes-frontend-ui/lib/material-content"));
	else
		root["VueDropUpload"] = factory(root["xes-frontend-ui/lib/utils/ajax"], root["xes-frontend-ui/lib/mixins/styleMixin"], root["xes-frontend-ui/lib/material-content"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_84__, __WEBPACK_EXTERNAL_MODULE_96__, __WEBPACK_EXTERNAL_MODULE_178__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition